import wildfireIconPack from "./packs/fireai_wildfire/icon-map"
import icpIconPack from "./packs/fireai_icp/icon-map"
import auIconPack from "./packs/fireai_au/icon-map"
import nwcgAirOpsPack from "./packs/nwcg_air_ops/icon-map"
import nwcgAssignmentBreakPack from "./packs/nwcg_assignment_break/icon-map"
import nwcgCommunicationsPack from "./packs/nwcg_communications/icon-map"
import nwcgFirePack from "./packs/nwcg_fire/icon-map"
import nwcgIRPack from "./packs/nwcg_ir/icon-map"
import nwcgLogisticsPack from "./packs/nwcg_logistics/icon-map"
import nwcgOpsPack from "./packs/nwcg_ops/icon-map"
import nwcgPropertyPack from "./packs/nwcg_property/icon-map"
import nwcgReferencePack from "./packs/nwcg_reference/icon-map"
import nwcgRepairPack from "./packs/nwcg_repair/icon-map"
import nwcgSafetyPack from "./packs/nwcg_safety/icon-map"
import nwcgTriagePack from "./packs/nwcg_triage/icon-map"
import nwcgWaterPack from "./packs/nwcg_water/icon-map"
import ForestryPack from "./packs/forestry/icon-map"

import nwcgLinesAirOps from "./packs/nwcg_lines_air_ops/icon-map"
import nwcgLinesFire from "./packs/nwcg_lines_fire/icon-map"
import nwcgLinesOpsCompleted from "./packs/nwcg_lines_ops_completed/icon-map"
import nwcgLinesOpsPlanned from "./packs/nwcg_lines_ops_planned/icon-map"
import nwcgLinesPerimeterLine from "./packs/nwcg_lines_perimeter_line/icon-map"
import nwcgLinesReference from "./packs/nwcg_lines_reference/icon-map"
import nwcgLinesRepair from "./packs/nwcg_lines_repair/icon-map"
import nwcgLinesRepairStatus from "./packs/nwcg_lines_repair_status/icon-map"
import nwcgLinesSafety from "./packs/nwcg_lines_safety/icon-map"
import nwcgLinesStrategicOperation from "./packs/nwcg_lines_strategic_operation/icon-map"

import nwcgPolygonsFire from "./packs/nwcg_polygons_fire/icon-map"
import nwcgPolygonsIR from "./packs/nwcg_polygons_ir/icon-map"
import nwcgPolygonsReference from "./packs/nwcg_polygons_reference/icon-map"

import nfpaEmergencyIncidents from "./packs/nfpa_emergency_incidents_symbology/icon-map"
import nfpaEmergencyNaturalEvents from "./packs/nfpa_emergency_natural_events_symbology/icon-map"
import nfpaEmergencyOperations from "./packs/nfpa_emergency_operations_symbology/icon-map"
import nfpaFireService from "./packs/nfpa_fire_service/icon-map"
import nfpaGeneralUse from "./packs/nfpa_general_use/icon-map"

import sarcopDamageObservations from "./packs/sarcop_damage_observations/icon-map"
import sarcopHazards from "./packs/sarcop_hazards/icon-map"
import sarcopIncidentSupport from "./packs/sarcop_incident_support/icon-map"
import sarcopSearchHumanNoFollowUp from "./packs/sarcop_search_human_interactions_that_do_not_need_follow_up_by_default/icon-map"
import sarcopSeachHumanWithFollowUp from "./packs/sarcrop_search_human_interactions_that_need_follow_up_by_default/icon-map"
import BCWSPack from "./packs/bcws/icon-map"

import numbers from "./packs/numbers/icon-map"

export type IconPackIcon = {
    name: string
    url: string
}

export type IconPack = Record<string, Record<string, IconPackIcon>>

//Icon Packs are used in the UI to display them in menus and modals
//The keys are the subheader titles within the menu
const NFPAEmergencyPack: IconPack = {
    "Operations Symbology": nfpaEmergencyOperations,
    "Incidents Symbology": nfpaEmergencyIncidents,
    "Natural Events Symbology": nfpaEmergencyNaturalEvents,
}

const NFPAFireServicePack: IconPack = {
    "Fire Service": nfpaFireService,
}

const NFPAGeneralUsePack: IconPack = {
    "General Use": nfpaGeneralUse,
}

const NWCGIconPack: IconPack = {
    "Accountable Property": nwcgPropertyPack,
    "Air Ops": nwcgAirOpsPack,
    "Assignment Break": nwcgAssignmentBreakPack,
    Communications: nwcgCommunicationsPack,
    Fire: nwcgFirePack,
    IR: nwcgIRPack,
    Logistics: nwcgLogisticsPack,
    Ops: nwcgOpsPack,
    Reference: nwcgReferencePack,
    Repair: nwcgRepairPack,
    Safety: nwcgSafetyPack,
    "Structure Triage": nwcgTriagePack,
    Water: nwcgWaterPack,
}

const NWCGLinePack: IconPack = {
    "Air Ops": nwcgLinesAirOps,
    Fire: nwcgLinesFire,
    "Ops Completed": nwcgLinesOpsCompleted,
    "Ops Planned": nwcgLinesOpsPlanned,
    "Perimeter Line": nwcgLinesPerimeterLine,
    Reference: nwcgLinesReference,
    Repair: nwcgLinesRepair,
    "Repair Status": nwcgLinesRepairStatus,
    Safety: nwcgLinesSafety,
    "Strategic Operation": nwcgLinesStrategicOperation,
}

const NWCGPolygonPack: IconPack = {
    Fire: nwcgPolygonsFire,
    IR: nwcgPolygonsIR,
    Reference: nwcgPolygonsReference,
}

const FireAIIconPack: IconPack = {
    Fireline: wildfireIconPack,
    "Down Under": auIconPack,
    ICP: icpIconPack,
}

const BCWSIconPack: IconPack = {
    "British Columbia Wildfire Service": BCWSPack,
}

const ForestryIconPack: IconPack = {
    Forestry: ForestryPack,
}

const SarcopIconPack: IconPack = {
    "Damage Observations": sarcopDamageObservations,
    Hazards: sarcopHazards,
    "Incident Support": sarcopIncidentSupport,
    "Search For Human With No Follow Up": sarcopSearchHumanNoFollowUp,
    "Search For Human With Follow Up": sarcopSeachHumanWithFollowUp,
}

const NumberPack = numbers

export {
    FireAIIconPack,
    NumberPack,
    NWCGIconPack,
    BCWSIconPack,
    ForestryIconPack,
    SarcopIconPack,
    NWCGLinePack,
    NWCGPolygonPack,
    NFPAEmergencyPack,
    NFPAGeneralUsePack,
    NFPAFireServicePack,
}
